"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const AdAnalyticsVideoIndexKeywordSection_1 = require("./AdAnalyticsVideoIndexKeywordSection");
class AdAnalyticsVideoIndexKeyword {
    constructor({ text, sections }) {
        this.toJSON = () => ({
            text: this.text,
            sections: this.sections.toJSON(),
        });
        this.text = text;
        this.sections = sections;
    }
}
AdAnalyticsVideoIndexKeyword.fromJSON = (json) => {
    const { text, sections } = Object.assign({}, json);
    if (typeof text !== 'string')
        throw new Error('.text must be a string');
    if (!Array.isArray(sections))
        throw new Error('.placements must be an array');
    const _sections = immutable_1.List(sections).map((item) => AdAnalyticsVideoIndexKeywordSection_1.default.fromJSON(item));
    return new AdAnalyticsVideoIndexKeyword({
        text,
        sections: _sections,
    });
};
exports.default = AdAnalyticsVideoIndexKeyword;
